import classes from './card.module.css'

import React from 'react';

const Card = ({children, extraClass}) =>{
    return(
        <div className={[classes.card, extraClass].join(' ')}>
            {children}
        </div>
    )
}

export default Card;